import cardBuilderHtmlMessages from "./cardBuilderHtmlMessages.jsx";

export default {
  ...cardBuilderHtmlMessages
}
